import React from "react";

export default function SQL_Any_All() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_Any_All</h1>
      <p>This is the SQL_Any_All component generated from the SQL JSON.</p>
    </div>
  );
}
